<ndt-register-view
  [name]="name"
  [totalCount]="totalCount"
  [callState]="callState"
  [hasNextPage]="hasNextPage"
  [pagingCallState]="pagingCallState"
  [searchText]="searchText"
  [showCreate]="blockedPhoneNumberPrivileges?.canEdit"
  (create)="onCreate()"
  (quickFilterChange)="onQuickFilterChange($event)"
  (loadMore)="onLoadMore()"
  >
  <lcs-responsive-table [columns]="columns">
    <table lcs-table [dataSource]="dataSource">
      <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
      <tr lcs-row *lcsResponsiveRowDef></tr>
      <ng-container lcsColumnDef="phoneNumber" width="5">
        <th lcs-header-cell *lcsHeaderCellDef id="phone-number-column-header">Phone Number</th>
        <td lcs-cell *lcsCellDef="let blockedPhoneNumber">
          {{ blockedPhoneNumber.phoneNumber | formatPhoneNumbers }}
        </td>
      </ng-container>
      <ng-container lcsColumnDef="comment" width="8">
        <th lcs-header-cell *lcsHeaderCellDef id="phone-number-column-header">Comment</th>
        <td lcs-cell *lcsCellDef="let blockedPhoneNumber">
          {{ blockedPhoneNumber.comment }}
        </td>
      </ng-container>
      <ng-container lcsColumnDef="blockedPhoneNumberActionsMenu" width="1">
        <th lcs-header-cell *lcsHeaderCellDef id="blocked-phone-number-actions-menu-column-header"></th>
        <td lcs-cell *lcsCellDef="let blockedPhoneNumber">
          @if (blockedPhoneNumberPrivileges?.canEdit) {
            <button
              type="button"
              aria-label="Blocked Phone Number Actions"
              matTooltip="More Actions"
              mat-icon-button
              [matMenuTriggerFor]="blockedPhoneNumberMenu"
              [disabled]="disabled"
              id="device-detail-more-actions"
              >
              <mat-icon> more_horiz </mat-icon>
            </button>
          }
          <mat-menu #blockedPhoneNumberMenu="matMenu">
            <button
              mat-menu-item
              type="button"
              id="call-history-details"
              (click)="onDeleteClick(blockedPhoneNumber.blockedPhoneNumberId, blockedPhoneNumber.phoneNumber)"
              >
              Unblock
            </button>
          </mat-menu>
        </td>
      </ng-container>
    </table>
  </lcs-responsive-table>
</ndt-register-view>
